import React, { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import { FormGroup, Label } from './styles/common';

function FormReactSelectResidenceInput({
  label, children, options, onChange, values, error, valid, disabled, labelClassName = '',
}) {
  const [prepOptions, setPrepOptions] = useState([]);
  const [inputText, setInputText] = useState('');

  const defaultBorder = '#CBCBCD';

  const filterMunicipalities = (inputValue) => {
    if (inputValue.length >= 3) {
      return prepOptions.filter((i) => i.label.toLowerCase().startsWith(inputValue.toLowerCase()));
    }

    return [];
  };

  const promiseOptions = (inputValue) => new Promise((resolve) => {
    setTimeout(() => {
      resolve(filterMunicipalities(inputValue));
    }, 500);
  });

  const handleChange = (value) => {
    if (value.residence_commune_code !== undefined || value.residence_commune_code !== '') {
      const commune = options.find((opt) => opt.cadastral_code === value.residence_commune_code);
      if (commune !== undefined) {
        onChange({
          residence_commune_code: commune.cadastral_code,
          residence_province_code: commune.communal_territory.car_plate_symbol,
          postal_code: commune.postal_code,
        });
      }
    }

    if (value.residence_commune_code === null || value.residence_commune_code === '' || value.residence_commune_code === undefined) {
      onChange({
        residence_commune_code: '',
        residence_province_code: '',
        postal_code: '',
      });
    }
  };

  const handleInputChange = (inputValue) => {
    setInputText(inputValue);
  };

  const handleMenuClose = () => {
    if (!values.residence_commune_code && inputText) {
      const startingWithOptions = prepOptions.filter((option) => option.label.toLowerCase().startsWith(inputText.toLowerCase()));
      const firstStartingOption = startingWithOptions[0];
      const findCarPlateSymbol = options.find((opt) => opt.cadastral_code === firstStartingOption.value);
      if (firstStartingOption && findCarPlateSymbol) {
        onChange({
          residence_commune_code: firstStartingOption.value,
          residence_province_code: findCarPlateSymbol.communal_territory.car_plate_symbol,
          postal_code: findCarPlateSymbol.postal_code,
        });
      }
    }
  };

  useEffect(() => {
    setPrepOptions(options.map((i) => ({ value: i.cadastral_code, label: `${i.name} (${i.communal_territory.car_plate_symbol})` })));
  }, [options]);

  return (
    <div className="d-flex align-items-start justify-content-between flex-wrap" style={{ columnGap: 20 }}>
      <FormGroup className="position-relative" style={{ flex: 2 }}>
        <Label className={labelClassName}>{label}</Label>
        <AsyncSelect
          onMenuClose={handleMenuClose}
          onInputChange={handleInputChange}
          loadOptions={promiseOptions}
          defaultOptions
          isSearchable={!disabled}
          placeholder=""
          value={options.filter((opt) => opt.cadastral_code === values.residence_commune_code).map((o) => ({ value: o.cadastral_code, label: `${o.name} (${o.communal_territory.car_plate_symbol})` }))[0]}
          onChange={(val) => {
            handleChange({
              residence_commune_code: val === null || val === undefined ? '' : val.value,
            });
          }}
          loadingMessage={() => 'Caricando communi...'}
          clearValue
          isClearable={!disabled}
          noOptionsMessage={() => (disabled ? null : 'Digita almeno tre lettere del comune!')}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderWidth: '2px !important',
              borderColor: `${error ? '#dc3545' : valid ? '#198754' : state.isSeleced ? defaultBorder : state.isFocused ? defaultBorder : defaultBorder}`,
              padding: '0.05rem 0.75rem',
              fontWeight: 'bold',
              borderRadius: '0.375rem',
              backgroundColor: '#FBFAFA',
              '&:hover': defaultBorder,
              boxShadow: 'none',
              textAlign: 'center',
            }),
          }}
        />
        <div className={`invalid-feedback ${error ? 'd-block' : ''}`}>{error}</div>
      </FormGroup>
      {children !== undefined
        && (
          <div style={{ flex: 1, flexBasis: 50 }}>
            {children}
          </div>
        )}
    </div>
  );
}

export default FormReactSelectResidenceInput;
